import { useDispatch, useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { alertActions } from "../../store";

const Alerts = () => {
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state.alert.alerts);

  const handleClose = (id) => {
    dispatch(alertActions.removeAlert(id));
  };
  return (
    <Stack
      sx={{
        mt: 1,
        position: "relative",
        zIndex: 2,
        alignItems: "center",
        width: "auto",
      }}
      spacing={2}
    >
      {alerts.map((alert) => (
        <Alert
          key={alert.id}
          severity={alert.severity}
          onClose={() => handleClose(alert.id)}
          sx={{
            m: 2,
            bgcolor: (theme) => theme.palette.primary.main,
            borderRadius: 0,
          }}
        >
          {alert.message}
        </Alert>
      ))}
    </Stack>
  );
};

export default Alerts;
